export default "__VITE_ASSET__D5bBX88v__"